import { Divider, List, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { memo } from "react";
import useRoute from "../../../hooks/useRoute";
import { scrollbarStyle } from "../../../shared/dashboard";
import { CompanyFile, Dashboard } from "../../../types/files";
import FileItem from "../../atoms/FileItem";

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        width: 400,
        height: 'fit-content',
        overflow: 'hidden',
        padding: 16,
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['100']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        transition: 'all 300ms ease-in-out',
    },
    title: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
        wordBreak: 'break-all',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontFamily: 'Poppins',
        fontSize: '1.2rem',
        fontWeight: '600',
        color: '#666666',
    },
    label: {
        fontFamily: 'Poppins',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        "&:hover": {
            textDecoration: 'underline',
        }
    },
    container: {
        width: '100%',
        height: '100%',
        background: '#fff',
        border: `1px solid ${theme.colors.neutral['300']}`,
        boxShadow: '0px 4px 10px -1px rgba(16, 24, 40, 0.06)',
        borderRadius: 16,
        padding: 16,
        breakInside: 'avoid',
        transition: '0.05s ease-in-out',
    },
    noteBlock: {
        width: '100%',
        height: '100%',
        minHeight: '67px',
        maxHeight: '112px',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    noteText: {
        fontFamily: 'Inter',
        fontSize: '0.9rem',
        color: theme.colors.neutral['600'],
    },
    categoriesContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        position: 'relative',
        alignContent: 'flex-start'
    },
    categoryContainer: {
        width: '100%'
    },
    emtpyState: {
        textAlign: 'center',
    },
    fileIcon: {
        marginRight: theme.spacing(1),
        height: 28,
        width: 28,
    },
    headerContainer: {
        marginBottom: 20,
    },
    categoryName: {
        fontWeight: 'bold',
        color: theme.palette.text.disabled,
        marginBottom: 15,
    },
}));

const DeckListContentCard: React.FC<{
    dashboard: Dashboard,
    files?: CompanyFile[],
    onSetDeck?: (file: CompanyFile) => Promise<any>,
 }> = ({ dashboard, files, onSetDeck }) => {
    const classes = useStyles();
    const { redirectToDashboard } = useRoute();

    return (<>
        <Stack direction="column" className={classes.card} spacing={1} justifyContent="stretch">
            <Typography className={classes.title}>
                {`All files for `}
                <Typography component="span" className={classes.label}
                    onClick={() => redirectToDashboard(dashboard.id)}
                    sx={{ cursor: 'pointer' }}
                    display="inline">
                    {dashboard.title}
                </Typography>
            </Typography>
            <Divider />
            <Stack spacing={1} alignItems="flex-start" width="100%">
                <List sx={{ width: "100%" }}>
                    {files?.map(file => (
                        <FileItem file={file} onSetDeck={onSetDeck}
                            key={'deck-list-content-card-172-' + file.id} />
                    ))}
                </List>
            </Stack>
        </Stack>
    </>);
};

export default memo(DeckListContentCard);
